export default __webpack_public_path__ + "media/zurb/img/playground/intent-formula-41740119dc4482ebdfc46bcaad531686.png";